<template>
  <div
    v-if="props.isOpen"
    class="modal fade show"
    style="display: block;"
    tabindex="-1"
    aria-modal="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('links.feedback') }}</h5>
          <button type="button" class="btn-close" @click="closeModal" aria-label="Close" />
        </div>
        <form @submit.prevent="handleSubmit">
          <div class="modal-body">
            <div class="mb-3">
              <textarea
                v-model="form.message"
                class="form-control"
                :placeholder="$t('info.feedbackPlaceholder')"
                :maxlength="maxLength"
                rows="5"
                required
              />
              <small class="text-muted">
                {{ form.message.length }} / {{ maxLength }}
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary btn-sm"
              :disabled="!isFormValid || loading"
            >
              {{ $t('buttons.submit') }}
            </button>
            <button type="button" class="btn btn-dark btn-sm" @click="closeModal">
              {{ $t('buttons.back') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref, computed,
} from 'vue';
import { useI18n } from 'vue-i18n';
// eslint-disable-next-line import/no-cycle
import { postfeedback } from '../api/api';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n();

const form = ref({
  message: '',
});

const maxLength = 500;
const loading = ref(false);
const error = ref('');

const isFormValid = computed(() => {
  const { message } = form.value;
  const { length } = message.trim();
  return length >= 10 && length <= maxLength;
});
const closeModal = () => {
  emit('close');
};

const handleSubmit = async () => {
  error.value = '';
  loading.value = true;

  try {
    const result = await postfeedback({ message: form.value.message.trim() });

    if (result?.status === 200) {
      globalThis.$toast?.showToast(t('info.actionSuccess'), 'success');
      form.value.message = '';
      closeModal();
    } else {
      throw new Error(t('errorsMsg.failedMsg'));
    }
  } catch (err) {
    error.value = err?.message || t('errorsMsg.error');
    globalThis.$toast?.showToast(error.value, 'danger');
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
